import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TelmChatComponent } from '../telm-chat.component';
import { Event } from './../../../../../_shared/model/event.model';

@Component({
    selector: 'telm-chat-portlet',
    templateUrl: './telm-chat-portlet.component.html',
    styles: [],
    imports: [TelmChatComponent],
})
export class TelmChatPortletComponent implements OnInit {
    @Input()
    set termData(data: Event) {
        if (data !== undefined) {
            this.selectedTerm = data;
        }
    }

    @Output()
    // TODO Ignored with eslint-interactive on 2023-11-10
    // eslint-disable-next-line @angular-eslint/no-output-on-prefix, @typescript-eslint/no-explicit-any
    public onLoad: EventEmitter<any> = new EventEmitter();

    public selectedTerm: Event;

    ngOnInit() {
        this.onLoad.emit();
    }
}
